<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <div class="div-query-banner" >
          <a-form-item label="发货时间：">
            <j-date placeholder="请选择发货日期从：" v-model="queryParam.begindateh"></j-date>
          </a-form-item>
          <a-form-item label="至:">
            <j-date placeholder="请选择至:" v-model="queryParam.enddateh"></j-date>
          </a-form-item>
          <a-form-item label="分公司名称">
              <a-input placeholder="请输入分公司名称" class="min-width-input" v-model="queryParam.companynameh"  readonly allowClear @change="handleCompanynamehChange"  >
                <div  slot="suffix"  >
                  <a-icon v-has="'logisticsList:company:all'"  type="appstore" @click="handleChooseCompanyAllClick" />
                  <a-icon v-has="'logisticsList:company:some'" type="appstore" @click="handleChooseCompanySomeClick" />
                </div>
              </a-input>
            </a-form-item>
           <a-form-item label="分公司编码">
              <a-input placeholder="请输入分公司编码" v-model="queryParam.companyidh"  disabled>
              </a-input>
            </a-form-item>
            <a-form-item label="当前用户">
              <a-input placeholder="请输入当前用户" disabled v-model="queryParam.usercodeh"></a-input>
            </a-form-item>
          <template v-if="toggleSearchStatus">
            <a-form-item label="原订单号">
              <a-input placeholder="请输入原订单号" v-model="queryParam.refcodeh"></a-input>
            </a-form-item>
            <a-form-item label="运输单号">
              <a-input placeholder="请输入运输单号" v-model="queryParam.doccodeh"></a-input>
            </a-form-item>
            <a-form-item label="展厅名称"> 
              <a-select  class="min-width-input"  v-model="queryParam.sdorgnameh" allowClear notFoundContent="找不到相关展厅" @change="handleSdorgidChange" :options="sdorgidhArr" ></a-select>
            </a-form-item>
            <a-form-item label="展厅编码">
              <a-input placeholder="选择展厅名称，自动带出来" v-model="queryParam.sdorgidh" disabled   ></a-input>
            </a-form-item>
            
            <a-form-item label="手工合同号">
              <a-input placeholder="请输入手工合同号" v-model="queryParam.predoccodeh"></a-input>
            </a-form-item>
            <a-form-item label="运输商编码">
              <a-input placeholder="请输入运输商编码" v-model="queryParam.transcodeh"></a-input>
            </a-form-item>
            <a-form-item label="运输商名称">
              <a-input placeholder="请输入运输商名称" v-model="queryParam.transnameh"></a-input>
            </a-form-item>
            <a-form-item label="运单号">
              <a-input placeholder="请输入运单号" v-model="queryParam.refcode1h"></a-input>
            </a-form-item>
            <a-form-item label="预计到货日">
              <j-date placeholder="请选择预计到货日" v-model="queryParam.beginplanh"></j-date>
            </a-form-item>
            <a-form-item label="结束时间">
              <j-date placeholder="请输入结束时间" v-model="queryParam.endplanh"></j-date>
            </a-form-item>
            <a-form-item label="线路">
              <a-input placeholder="请输入线路" v-model="queryParam.circuitlineh"></a-input>
            </a-form-item>
            <a-form-item label="安装地址">
              <a-input placeholder="请输入安装地址" v-model="queryParam.sendaddressh"></a-input>
            </a-form-item>
            <a-form-item label="工程项目">
              <a-input placeholder="请输入工程项目" v-model="queryParam.projecth"></a-input>
            </a-form-item>
            <a-form-item label="提示信息">
              <a-input placeholder="请输入提示信息" v-model="queryParam.info"></a-input>
            </a-form-item>
          </template>
          <div class="margin-left-auto"  >
            <a-button type="primary" @click="searchQuery"   icon="search" >查询</a-button>
            <a-button type="primary" @click="initParams" icon="reload" style="margin-left: 8px">重置</a-button>
          </div>
        </div>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button type="primary" icon="download" @click="handleExportXls('展厅物流信息')">导出</a-button>
      <!-- <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete" />删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown> -->
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :scroll="{x:true}"
        :rowSelection="{ fixed: true, selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic">无此图片</span>
          <img
            v-else
            :src="getImgView(text)"
            height="25px"
            alt="图片不存在"
            style="max-width: 80px; font-size: 12px; font-style: italic"
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic">无此文件</span>
          <a-button v-else :ghost="true" type="primary" icon="download" size="small" @click="uploadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>
    <depart-window ref="departWindow" permissionType="all" @selected="handleChooseCompanyClickSelected"></depart-window>
    <depart-window ref="departWindowSome" permissionType="some" @selected="handleChooseCompanyClickSelected"></depart-window>
  </a-card>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import JDate from '@/components/jeecg/JDate.vue'
import {selectCompanyByUserCode,selectShowroomInfoByCompanyId} from '@/api/api.js'
import moment from 'moment'
import { USER_INFO } from "@/store/mutation-types"
import Vue from 'vue'
import DepartWindow from './components/DepartWindow.vue'
import { getAction } from '@/api/manage'

export default {
  name: 'LogisticsInformationList',
  mixins: [JeecgListMixin],
  components: {
    JDate,DepartWindow
  },
  data() {
    return {
      description: '展厅物流信息管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '发货日期',
          align: 'center',
          dataIndex: 'docdate',
          customRender: function (text) {
            return !text ? '' : text.length > 10 ? text.substr(0, 10) : text
          },
        },
        {
          title: '运输单号',
          align: 'center',
          dataIndex: 'doccode',
        },
        {
          title: '运单状态',
          align: 'center',
          dataIndex: 'shipmentStatus',
        },
        {
          title: '原订单号',
          align: 'center',
          dataIndex: 'refcode',
        },
        {
          title: '运单号',
          align: 'center',
          dataIndex: 'refcode1',
        },
        {
          title: '预计到货日期',
          align: 'center',
          dataIndex: 'plandate',
          customRender: function (text) {
            return !text ? '' : text.length > 10 ? text.substr(0, 10) : text
          },
        },
        {
          title: '物流件数',
          align: 'center',
          dataIndex: 'sumnumber',
        },
        {
          title: '物流费用',
          align: 'center',
          dataIndex: 'summoney',
        },
        {
          title: '区域',
          align: 'center',
          dataIndex: 'companyname',
        },
        {
          title: '展厅编码',
          align: 'center',
          dataIndex: 'sdorgid',
        },
        {
          title: '展厅名称',
          align: 'center',
          dataIndex: 'sdorgname',
        },
        {
          title: '手工合同单号',
          align: 'center',
          dataIndex: 'predoccode',
        },
        {
          title: '物流公司',
          align: 'center',
          dataIndex: 'transname',
        },
        {
          title: '备注',
          align: 'center',
          dataIndex: 'cv24',
        },
        {
          title: '柜体',
          align: 'center',
          dataIndex: 'cv1',
        },
        {
          title: '门板',
          align: 'center',
          dataIndex: 'cv2',
        },
        {
          title: '顶线',
          align: 'center',
          dataIndex: 'cv3',
        },
        {
          title: '踢脚板',
          align: 'center',
          dataIndex: 'cv4',
        },
        {
          title: '玻璃层门',
          align: 'center',
          dataIndex: 'cv5',
        },
        {
          title: '弧吊工艺',
          align: 'center',
          dataIndex: 'cv6',
        },
        {
          title: '衣柜移门',
          align: 'center',
          dataIndex: 'cv7',
        },
        {
          title: '米箱',
          align: 'center',
          dataIndex: 'cv8',
        },
        {
          title: '垃圾桶',
          align: 'center',
          dataIndex: 'cv9',
        },
        {
          title: '龙头',
          align: 'center',
          dataIndex: 'cv10',
        },
        {
          title: '水槽',
          align: 'center',
          dataIndex: 'cv11',
        },
        {
          title: '拉蓝',
          align: 'center',
          dataIndex: 'cv12',
        },
        {
          title: '灶',
          align: 'center',
          dataIndex: 'cv13',
        },
        {
          title: '烟机',
          align: 'center',
          dataIndex: 'cv14',
        },
        {
          title: '烟管',
          align: 'center',
          dataIndex: 'cv15',
        },
        {
          title: '消毒柜',
          align: 'center',
          dataIndex: 'cv16',
        },
        {
          title: '置物架',
          align: 'center',
          dataIndex: 'cv17',
        },
        {
          title: '配件箱',
          align: 'center',
          dataIndex: 'cv18',
        },
        {
          title: '台板',
          align: 'center',
          dataIndex: 'cv19',
        },
        {
          title: '烤箱',
          align: 'center',
          dataIndex: 'cv20',
        },
        {
          title: '其它件数',
          align: 'center',
          dataIndex: 'cv21',
        },
        {
          title: '其它物品',
          align: 'center',
          dataIndex: 'cv22',
        },
        {
          title: '净水器',
          align: 'center',
          dataIndex: 'cv232',
        },
        {
          title: '蒸炉',
          align: 'center',
          dataIndex: 'cv242',
        },
        {
          title: '冰箱',
          align: 'center',
          dataIndex: 'cv25',
        },
        {
          title: '怪物组',
          align: 'center',
          dataIndex: 'cv26',
        },
        {
          title: '灯具',
          align: 'center',
          dataIndex: 'cv27',
        },
        {
          title: '磨砂玻璃',
          align: 'center',
          dataIndex: 'cv28',
        },
        {
          title: '环艺厨居',
          align: 'center',
          dataIndex: 'cv29',
        },
        {
          title: '资料',
          align: 'center',
          dataIndex: 'cv30',
        },
        {
          title: '电陶/微波',
          align: 'center',
          dataIndex: 'cv32',
        },
        {
          title: '马桶',
          align: 'center',
          dataIndex: 'cv33',
        },
        {
          title: '处理器',
          align: 'center',
          dataIndex: 'cv34',
        },
        {
          title: '挡灰板',
          align: 'center',
          dataIndex: 'cv35',
        },
        {
          title: '按摩椅',
          align: 'center',
          dataIndex: 'cv36',
        },
        {
          title: '恒温酒柜',
          align: 'center',
          dataIndex: 'cv37',
        },
        {
          title: '木门门类',
          align: 'center',
          dataIndex: 'cv38',
        },
        {
          title: '木门线条类',
          align: 'center',
          dataIndex: 'cv39',
        },
        {
          title: '隐形床',
          align: 'center',
          dataIndex: 'cv40',
        },
        {
          title: '拉直器',
          align: 'center',
          dataIndex: 'cv41',
        },
        {
          title: '密码抽',
          align: 'center',
          dataIndex: 'cv42',
        },
        {
          title: '收纳抽',
          align: 'center',
          dataIndex: 'cv43',
        },
        {
          title: '收纳盒',
          align: 'center',
          dataIndex: 'cv44',
        },
        {
          title: '升降机',
          align: 'center',
          dataIndex: 'cv45',
        },
        {
          title: '西裤架',
          align: 'center',
          dataIndex: 'cv46',
        },
        {
          title: '衣物篮',
          align: 'center',
          dataIndex: 'cv47',
        },
        {
          title: '鞋架',
          align: 'center',
          dataIndex: 'cv48',
        },
        {
          title: '镜子',
          align: 'center',
          dataIndex: 'cv49',
        },
        {
          title: '木门门类',
          align: 'center',
          dataIndex: 'cv50',
        },
        {
          title: '木门线条类',
          align: 'center',
          dataIndex: 'cv51',
        },
        {
          title: '9mm柜体',
          align: 'center',
          dataIndex: 'cv52',
        },
        {
          title: '拉手',
          align: 'center',
          dataIndex: 'cv53',
        },
        {
          title: '备注说明/体积',
          align: 'center',
          dataIndex: 'hdtext',
        },
        {
          title: '标识',
          align: 'center',
          dataIndex: 'timeout',
        },
        {
          title: '运费承担',
          align: 'center',
          dataIndex: 'transpayment',
        },
        {
          title: '区域收货时间',
          align: 'center',
          dataIndex: 'date23',
          customRender: function (text) {
            return !text ? '' : text.length > 10 ? text.substr(0, 10) : text
          },
        },
        {
          title: '到货异常',
          align: 'center',
          dataIndex: 'yctext',
        },
        {
          title: '制单人',
          align: 'center',
          dataIndex: 'entername',
        },
        {
          title: '序号',
          align: 'center',
          dataIndex: 'item',
        },
        {
          title: '检验员',
          align: 'center',
          dataIndex: 'checker',
        },
        {
          title: '检验记录',
          align: 'center',
          dataIndex: 'checktext',
        },
        {
          title: '责任部门',
          align: 'center',
          dataIndex: 'ccname',
        },
        {
          title: '备注',
          align: 'center',
          dataIndex: 'hdtext3',
        },
        {
          title: '加工厂发货',
          align: 'center',
          dataIndex: 'fhdate',
          customRender: function (text) {
            return !text ? '' : text.length > 10 ? text.substr(0, 10) : text
          },
        },
        {
          title: '套数',
          align: 'center',
          dataIndex: 'tdigit',
        },
        {
          title: '非加盟商责任扣除运费',
          align: 'center',
          dataIndex: 'ycmoney',
        },
        {
          title: 'PDA扫描人',
          align: 'center',
          dataIndex: 'pdauser',
        },
        {
          title: '供应商信息',
          align: 'center',
          dataIndex: 'vndname',
        },
        {
          title: '发货地',
          align: 'center',
          dataIndex: 'dispatch',
        },
        {
          title: '线路',
          align: 'center',
          dataIndex: 'circuitline',
        },
        {
          title: '安装地址',
          align: 'center',
          dataIndex: 'sendaddress',
        },
        {
          title: '备注',
          align: 'center',
          dataIndex: 'hdtexthd',
        },
        {
          title: '零售单|订单日期',
          align: 'center',
          dataIndex: 'lsdocdate',
          customRender: function (text) {
            return !text ? '' : text.length > 10 ? text.substr(0, 10) : text
          },
        },
        {
          title: '零售单|原合同号',
          align: 'center',
          dataIndex: 'lspredoccode',
        },
        {
          title: '移交备注',
          align: 'center',
          dataIndex: 'transremark',
        },
        {
          title: '物流状态',
          align: 'center',
          dataIndex: 'state',
        },
        {
          title: '签收状态',
          align: 'center',
          dataIndex: 'signstate',
        },
        {
          title: '签收备注',
          align: 'center',
          dataIndex: 'signremarks',
        },
        {
          title: '异常备注',
          align: 'center',
          dataIndex: 'exceptiontext',
        },
        {
          title: '体积',
          align: 'center',
          dataIndex: 'opdigit',
        },
      ],
      url: {
        list: '/erp/showroomlogistics/logisticsInformation/list',
        delete: '/erp/showroomlogistics/logisticsInformation/delete',
        deleteBatch: '/erp/showroomlogistics/logisticsInformation/deleteBatch',
        exportXlsUrl: '/erp/showroomlogistics/logisticsInformation/exportXls',
        importExcelUrl: 'erp/showroomlogistics/logisticsInformation/importExcel',
      },
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " 共" + total + "条"
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      dictOptions: {},
      disableMixinCreated:true,
      toggleSearchStatus:true,
      sdorgidhArr:[],
      dataSourceAll:[],
    }
  },
  created() {
    this.initParams();
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    initParams() {
      this.$set(this.queryParam,"begindateh",moment().subtract(1, "months").format("YYYY-MM-DD"))
      this.$set(this.queryParam,"enddateh",moment().format("YYYY-MM-DD"))
      // 获取用户信息
      let userInfo= Vue.ls.get(USER_INFO)
      if(!userInfo || !userInfo.username){
        this.$message.error("找不到用户，请重新登陆")
        return
      }
      this.$set(this.queryParam,"usercodeh",userInfo.username);
      this.searchReset()
    },
    searchReset(){
      if(!this.queryParam.usercodeh){
        this.$message.error("请填写用户编码")
        return
      }
      selectCompanyByUserCode({usercodeh:this.queryParam.usercodeh}).then(res=>{
        if(res.code===200){
          if(!res.result){
            this.$message.error("查不到这个人的分公司")
            return
          }
          let shopArr=res.result.sdorgList
          this.$set(this.queryParam,"companynameh",res.result.companynameh);
          this.$set(this.queryParam,"companyidh",res.result.companyidh);
          if(shopArr.length===1){
            this.$set(this.queryParam,"sdorgidh",shopArr[0].sdorgidh);
            this.$set(this.queryParam,"sdorgnameh",shopArr[0].sdorgnameh);
          }else{
            this.$set(this.queryParam,"sdorgidh","");
            this.$set(this.queryParam,"sdorgnameh","");
          }
          this.sdorgidhArr=shopArr.map(item=>{
            return {
              label:item.sdorgnameh,
              value:item.sdorgidh,
              key:item.sdorgidh,
            }
          })
          this.loadData(1);
        }else{
          this.$message.error(res.message)
        }
      }).catch(error=>{
        this.$message.error(error.message)
      })
    },
    handleSdorgidChange(value){
      this.$set(this.queryParam,"sdorgidh",value)
    },
    unique(arr) {
        let newArr = [arr[0]];
        for (let i = 1; i < arr.length; i++) {
            let repeat = false;
            for (let j = 0; j < newArr.length; j++) {
                if (arr[i].sdorgidh === newArr[j].sdorgidh) {
                    repeat = true;
                    break;
                }
            }
            if (!repeat) {
                newArr.push(arr[i]);
            }
        }
        return newArr;
    },
    handleChooseCompanyAllClick(){
      this.$refs.departWindow.open();
    },
    handleChooseCompanySomeClick(){
      this.$refs.departWindowSome.open();
    },
    handleChooseCompanyClickSelected(value){
      this.$set(this.queryParam,"companynameh",value.companynameh);
      this.$set(this.queryParam,"companyidh",value.companyidh);
      selectShowroomInfoByCompanyId({companyidh:value.companyidh}).then(res=>{
        if(res.code==200){
          let shopArr=res.result
          this.$set(this.queryParam,"sdorgidh","");
          this.$set(this.queryParam,"sdorgnameh","");
          this.sdorgidhArr=shopArr.map(item=>{
            return {
              label:item.sdorgnameh,
              value:item.sdorgidh,
            }
          })
          this.loadData(1);
        }else{
          this.$message.error(res.message)
        }
      }).catch(error=>{
        this.$message.error(error.message)
      })
      
    },
    loadData (arg) {
      if (!this.url.list) {
          this.$message.error("请设置url.list属性!")
          return
      }
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
          this.ipagination.current = 1;
      }
      var params = this.getQueryParams();//查询条件
      this.loading = true;
      this.dataSource=[]
      getAction(this.url.list, params).then((res) => {
          if (res.success) {
            this.dataSourceAll= res.result;
            this.ipagination.total = res.result.length;
            this.dataSource = this.dataSourceAll.slice(0,this.ipagination.pageSize)
            this.pageRefresh ++
          }else{
              this.$message.warning(res.message)
          }  
          if (res.code === 510) {
              this.$message.warning(res.message)
          }
          this.loading = false;
      })
    },
    handleTableChange (pagination, filters, sorter) {
      //分页、排序、筛选变化时触发
      //TODO 筛选
      if (Object.keys(sorter).length > 0) {
          this.isorter.column = sorter.field;
          this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
      }
      this.ipagination = pagination;
      this.dataSource = this.dataSourceAll.slice((this.ipagination.current-1)*this.ipagination.pageSize,((this.ipagination.current-1)*this.ipagination.pageSize+this.ipagination.pageSize))
    },
    handleCompanynamehChange(){
      this.$set(this.queryParam,'companyidh',undefined)
    }
  },
}
</script>
<style lang="less" scoped>
@import '~@assets/less/common.less';
  .div-query-banner{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    &>*:nth-child(n){
      margin-left: 0px;
      margin-bottom: 7px;
      /deep/.ant-form-item-label{
        width: 100px !important;
      }
      .ant-calendar-picker{
        width: 183px !important;
      }
      .min-width-input{
        width: 183px !important;
      }
    }
    &>.query-banner-btn:nth-child(n){
      width:100px
    }
    .margin-left-10{
      margin-left: 10px;
    }
    .margin-left-auto{
        margin-left: 100px;
    }
  }
  .table-operator{
    margin-top: 30px;
  }
</style>